import {useRef, useState} from "react";
import {BiSearch, BiMapPin} from "react-icons/bi";

import MassesTimeSearch from "@/components/shared/masses-time";
import ClergiesBlock from "./clergies-block";
import {getPriest} from "@/services/home-service";

export default function ClergySearch({
                                         title = "GIÁO PHẬN PHÚ CƯỜNG",
                                         tabs = [
                                             {id: "spiritual", label: "Thông Tin Linh Mục"},
                                             {id: "diocese", label: "Giờ Lễ - Giáo Hạt - Giáo Xứ"},
                                         ],
                                         deaneries,
                                         className = "",
                                     }) {
    const [activeTab, setActiveTab] = useState(tabs[0].id);
    const [clergies, setClergies] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [churches, setChurches] = useState({total: 0, value: []});
    const [churchHasMore, setChurchHasMore] = useState(false);
    const [churchPage, setChurchPage] = useState(1);
    const [hasChurchSearched, setHasChurchSearched] = useState(false);
    const [isChurchSearching, setIsChurchSearching] = useState(false);
    const [churchSearchData, setChurchSearchData] = useState({
        //search nhà thờ - giờ lễ
        deaneryId: "",
        churchName: "",
        timeMass: "",
        pageSize: 10,
    });
    const [searchData, setSearchData] = useState({
        // search linh mục
        clergyName: "",
        deaneryId: "",
        pageSize: 10,
        page: 1,
    });
    const deaneriesData = Array.isArray(deaneries?.value)
        ? deaneries.value
        : Array.isArray(deaneries)
            ? deaneries
            : [];

    const nullDeanery = {
        id: "",
        name: "Chọn Giáo Hạt",
        value: "",
    };

    const combinedDeaneries = [nullDeanery, ...deaneriesData];
    const scrollRef = useRef(null);

    //search linh mục
    const handleSearch = async (append = false) => {
        const {appointmentID, churchName, timeMass, ...rest} = searchData;

        const trimmedClergy = rest.clergyName?.trim() || "";

        // xác định trang để gửi request
        const nextPage = append ? (searchData.page || 1) + 1 : (searchData.page || 1);

        const params = {
            ...rest,
            clergyName: trimmedClergy,
            page: nextPage,
        };

        const response = await getPriest(params);

        if (append) {
            // Thêm kết quả vào danh sách hiện có.
            setClergies((prev) => {
                const prevVals = prev?.value || [];
                const newVals = response?.value || [];
                return {
                    ...response,
                    value: [...prevVals, ...newVals],
                    pageData: response.pageData,
                };
            });
            setSearchData((prev) => ({...prev, page: nextPage}));
            const returnedCount = response?.value?.length ?? 0;
            setHasMore(returnedCount >= params.pageSize);
        } else {
            setClergies(response);
            setSearchData((prev) => ({...prev, page: nextPage}));
            const returnedCount = response?.value?.length ?? 0;
            setHasMore(returnedCount >= params.pageSize);
        }
    };

    const requestChurchSearch = async (params) => {
        const response = await fetch("api/churchs", {
            method: "POST",
            body: JSON.stringify(params),
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.json();
    };

    const handleInputChange = (field, value) => {
        setSearchData((prev) => ({
            ...prev,
            [field]: value,
            // reset về page đầu tiên khi input thay đổi
            ...(field === 'clergyName' || field === 'deaneryId' ? {page: 1} : {}),
        }));

        if (field === 'clergyName' || field === 'deaneryId') {
            setClergies([]);
            setHasMore(false);
        }
    };

    const handleChurchSearch = async (append = false) => {
        const nextPage = append ? churchPage + 1 : 1;
        const params = {
            ...churchSearchData,
            page: nextPage,
        };

        if (!append) {
            setHasChurchSearched(true);
        }

        setIsChurchSearching(true);

        try {
            const data = await requestChurchSearch(params);

            if (append) {
                setChurches((prev) => ({
                    ...data,
                    value: [...(prev?.value || []), ...(data?.value || [])],
                }));
            } else {
                setChurches(data);
            }

            setChurchPage(nextPage);

            const pageData = data?.pageData || {};
            const currentPage = pageData.currentPage || nextPage;
            const pageCount = pageData.pageCount || 0;
            const returnedCount = data?.value?.length ?? 0;
            setChurchHasMore(pageCount ? currentPage < pageCount : returnedCount >= params.pageSize);
        } finally {
            setIsChurchSearching(false);
        }
    };

    const handleChurchInputChange = (field, value) => {
        setChurchSearchData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setChurches({total: 0, value: []});
        setChurchHasMore(false);
        setChurchPage(1);
        setHasChurchSearched(false);
        setIsChurchSearching(false);
    };

    return (
        <div className={`w-full ${className}`}>
            {/* Title */}
            <h1 className="text-3xl font-bold text-primary text-center mb-6">
                {title}
            </h1>

            {/* Tabs */}
            {/* TODO:  */}
            <div className="flex justify-center gap-3 mb-6">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`px-6 py-3 rounded-full font-medium transition-all ${
                            activeTab === tab.id
                                ? "bg-primary text-white shadow-md"
                                : "bg-white text-gray-700 hover:bg-gray-50 border border-gray-300"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Search Form */}
            {/* TODO:  */}
            {activeTab === "spiritual" ? (
                <div className="bg-gray-200 rounded-2xl p-6 shadow-lg">
                    <div className="flex flex-col md:flex-row gap-3 mb-4">
                        {/* Name/Title Input */}
                        <div className="flex-[2] relative">
                            <BiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"/>
                            <input
                                type="text"
                                placeholder="Nhập tên linh mục"
                                value={searchData.clergyName}
                                onChange={(e) =>
                                    handleInputChange(
                                        "clergyName",
                                        e.target.value
                                    )
                                }
                                className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        {/* Parish Dropdown */}
                        <div className="flex-1 relative">
                            <BiMapPin className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl"/>
                            <select
                                value={searchData.deaneryId}
                                onChange={(e) =>
                                    handleInputChange("deaneryId", e.target.value)
                                }
                                className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white cursor-pointer"
                            >
                                {combinedDeaneries.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Search Button */}
                        <button
                            onClick={() => handleSearch(false)}
                            className="px-8 py-3.5 bg-cyan-500 hover:bg-cyan-600 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md"
                        >
                            <BiSearch className="text-xl"/>
                            <span>Tìm kiếm</span>
                        </button>
                    </div>
                    {clergies?.value && (
                        <div
                            ref={scrollRef}
                            className="w-full h-[600px] overflow-y-auto bg-gray-50 rounded-lg p-6"
                        >
                            <ClergiesBlock
                                clergies={clergies}
                                isPagination={true}
                                hasMore={hasMore}
                                actions={{
                                    onLoadMore: async () => {
                                        // chỉ load khi có nhiều hơn 1 page
                                        if (!clergies?.pageData) return;
                                        const {currentPage, pageCount} = clergies.pageData;
                                        if (currentPage >= pageCount) return;
                                        // gọi handleSearch với append = true để thêm kết quả vào danh sách hiện tại
                                        await handleSearch(true);
                                    },
                                }}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <MassesTimeSearch
                    deaneries={deaneriesData}
                    searchData={churchSearchData}
                    churches={churches}
                    hasMore={churchHasMore}
                    hasSearched={hasChurchSearched}
                    isSearching={isChurchSearching}
                    handleSearch={handleChurchSearch}
                    handleInputChange={handleChurchInputChange}
                    handleLoadMore={() => handleChurchSearch(true)}
                />
            )}
        </div>
    );
}
